<select
  class="border border-gray-300 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
  [value]="selectedSeasonId() ?? ''"
  (change)="onSelect($any($event.target).value)"
>
  <option value="">Toutes les saisons</option>
  @for (season of seasons(); track season.sportseason_id) {
    <option [value]="season.sportseason_id">{{ season.sportseason_name }}</option>
  }
</select>
